import CreateChildAndStartCheck from "./CreateChildAndStartCheck";

export const SPECIAL_ACTIONS = {
    CREATE_CHILD_AND_START_CHECK: "create-child-and-start-check",
    // LINK_PARENT_AND_START_CHECK: "link-parent-and-start-check",
} as const;

type SpecialActionType =
    typeof SPECIAL_ACTIONS[keyof typeof SPECIAL_ACTIONS];

type SpecialActionConfigItem = {
    type: SpecialActionType;
    [key: string]: any;
};

export const SpecialActionComponents: Record<
    SpecialActionType,
    (props: SpecialActionConfigItem) => JSX.Element
> = {
    [SPECIAL_ACTIONS.CREATE_CHILD_AND_START_CHECK]: (props) => (
        <CreateChildAndStartCheck {...((props as any).field || props)} />
    ),
    // [SPECIAL_ACTIONS.LINK_PARENT_AND_START_CHECK]: (props) => <LinkParentAndStartCheck {...props} />
};

type SpecialActionsProps = {
    special_actions: SpecialActionConfigItem[];
};

export default function SpecialActions({ special_actions }: SpecialActionsProps) {
    return special_actions.map((i, index) => (
        <div key={index} className="d-inline-flex d-lg-block">
            {SpecialActionComponents[i.type](i)}
        </div>
    ));
}

